import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import { generateAssetQRCodeDataURL } from "../../utils/helper";

const styles = StyleSheet.create({
  page: {
    padding: 20,
    display: "flex",
    flexDirection: "row",
    gap: 2,
    flexWrap: "wrap",
  },
  section: { marginBottom: 0, width: "30%" },
  text: { marginBottom: 10, fontSize: 14 },
});
export const QrPDF = ({ type, assets }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      {assets.map((asset, index) => (
        <View wrap={false} key={index} style={styles.section}>
          {type == "Asset" && (
            <Text style={styles.text}>{asset.asset_name}</Text>
          )}
          {type == "Part" && (
            <Text style={styles.text}>{asset.part.part_name}</Text>
          )}
          <Image
            src={generateAssetQRCodeDataURL(asset.barcode)}
            style={{ width: "100%" }}
          />
        </View>
      ))}
    </Page>
  </Document>
);
